import { coreAppUserFields, coreMediaPointFields, corePortalUserFields, recordingSettingsFields } from '../query-fields';
import { gql } from 'graphql-tag';

export const iamGroupOfAppUserFields = `
  id
  name
  membershipType
`;

export const iamMediaPointOfAppUserFields = `
  id
  name
  serviceUsername
  extensionNumber
  type

  serviceId
  serviceName
  serviceType
  serviceTypeName
  serviceRootPath

  recordingSettings {
    ${recordingSettingsFields}
  }
`;

export const iamAppUserWithPortalUserFields = `
  ${coreAppUserFields}
  portalUser {
    ${corePortalUserFields}
  }
`;

export const iamAppUserWithMediaPointFields = `
  ${coreAppUserFields}
  mediaPoints {
    ${iamMediaPointOfAppUserFields}
  }
`;

export const iamAppUserWithPortalUserMediaPointGroupFields = `
  ${coreAppUserFields}
  portalUser {
    ${corePortalUserFields}
  }
  mediaPoints {
    ${iamMediaPointOfAppUserFields}
  }
  groups {
    ${iamGroupOfAppUserFields}
  }
`;

export const iamAppUserMembershipFields = `
  id
  appUserId
  groupId
  accountId
  name
  status
  description
  permissions
  membershipType
`;

export const searchIamAppUsersResponseFields = `
  totalCount
  appUsers {
    ${iamAppUserWithPortalUserMediaPointGroupFields}
  }
`;

export const iamMediaPointFields = `
  ${coreMediaPointFields}
  appUsers {
    id
    name
  }
`;

export const getIamAppUsersAvailableForGroupQuery = gql`
  query getAppUsersAvailableForGroup {
    getAppUsersAvailableForGroup {
      ${coreAppUserFields}
    }
  }
`;

export const getIamPortalUsersAvailableForAppUserQuery = gql`
  query getPortalUsersAvailableForAppUser {
    getPortalUsersAvailableForAppUser {
      ${corePortalUserFields}
    }
  }
`;

export const getIamMediaPointsAvailableForAppUserQuery = gql`
  query getMediaPointsAvailableForAppUser($id: ID!) {
    getMediaPointsAvailableForAppUser(id: $id) {
      ${iamMediaPointOfAppUserFields}
    }
  }
`;

export const getIamAppUsersAvailableForMediaPointQuery = gql`
  query getAppUsersAvailableForMediaPoint($id: ID!) {
    getAppUsersAvailableForMediaPoint(id: $id) {
      ${coreAppUserFields}
    }
  }
`;

export const searchIamAppUsersQuery = gql`
  query searchAppUsers($input: SearchAppUsersInput!) {
    searchAppUsers(input: $input) {
      ${searchIamAppUsersResponseFields}
    }
  }
`;

export const getIamAppUserQuery = gql`
  query getAppUser($input: GetAppUserInput!) {
    getAppUser(input: $input) {
      ${iamAppUserWithPortalUserMediaPointGroupFields}
    }
  }
`;

export const lookupIamAppUsersByNameQuery = gql`
  query lookupAppUsersByName($name: String!) {
    lookupAppUsersByName(name: $name) {
      ${coreAppUserFields}
    }
  }
`;


export const createIamAppUserMutation = gql`
  mutation createAppUser($input: CreateAppUserInput!) {
    createAppUser(input: $input) {
      ${coreAppUserFields}
    }
  }
`;

export const updateIamAppUserMutation = gql`
  mutation updateAppUser($input: UpdateAppUserInput!) {
    updateAppUser(input: $input) {
      ${coreAppUserFields}
    }
  }
`;

export const deleteIamAppUserMutation = gql`
  mutation deleteAppUser($input: DeleteAppUserInput!) {
    deleteAppUser(input: $input) {
      ${coreAppUserFields}
    }
  }
`;

export const attachIamPortalUserMutation = gql`
  mutation attachAppUserToPortalUser($input: AttachAppUserToPortalUserInput!) {
    attachAppUserToPortalUser(input: $input) {
      ${iamAppUserWithPortalUserFields}
    }
  }
`;

export const detachIamPortalUserMutation = gql`
  mutation detachAppUserFromPortalUser($input: DetachAppUserFromPortalUserInput!) {
    detachAppUserFromPortalUser(input: $input) {
      ${iamAppUserWithPortalUserFields}
    }
  }
`;

export const attachIamMediaPointToAppUserMutation = gql`
  mutation attachMediaPointToAppUser($input: AttachMediaPointToAppUserInput!) {
    attachMediaPointToAppUser(input: $input) {
      ${iamAppUserWithMediaPointFields}
    }
  }
`;

export const detachIamMediaPointFromAppUserMutation = gql`
  mutation detachMediaPointFromAppUser($input: DetachMediaPointFromAppUserInput!) {
    detachMediaPointFromAppUser(input: $input) {
      ${iamAppUserWithMediaPointFields}
    }
  }
`;

export const attachIamAppUserToMediaPointMutation = gql`
  mutation attachAppUserToMediaPoint($input: AttachAppUserToMediaPointInput!) {
    attachAppUserToMediaPoint(input: $input) {
      ${iamMediaPointFields}
      appUser {
        id
        name
      }
    }
  }
`;

export const detachIamAppUserFromMediaPointMutation = gql`
  mutation detachAppUserFromMediaPoint($input: DetachAppUserFromMediaPointInput!) {
    detachAppUserFromMediaPoint(input: $input) {
      ${iamMediaPointFields}
      appUser {
        id
        name
      }
    }
  }
`;

